import { AlpineComponent } from 'alpinejs';

interface BookmarkToggleResponse {
	bookmarked: boolean;
}

interface BookmarkToggleData {
	bookmarked: boolean;
	toggle(): Promise<void>;
	removeFromLibrary(): void;
}

const bookmarkToggle = (
	bookmarked: boolean,
	bookmarkUrl: string,
	removeOnUnbookmark = false,
): AlpineComponent<BookmarkToggleData> => ({
	bookmarked,

	async toggle() {
		const rsp = await fetch(bookmarkUrl, { method: 'POST' });
		const data = (await rsp.json()) as BookmarkToggleResponse;
		this.bookmarked = data.bookmarked;

		if (removeOnUnbookmark && !this.bookmarked) {
			this.removeFromLibrary();
		}
	},

	removeFromLibrary() {
		const row = this.$el.closest<HTMLElement>('[data-bookmark-row]');
		if (!row) return;

		const accordion = row.closest<HTMLElement>('.accordion');
		const part = row.closest<HTMLElement>('[data-bookmarked-part]');

		row.remove();

		if (part && part.querySelectorAll('[data-bookmark-row]').length === 0) {
			part.closest('li')?.remove();
		}

		if (accordion && accordion.querySelectorAll('[data-bookmarked-part]').length === 0) {
			accordion.remove();
		}

		if (document.querySelectorAll('.accordion').length === 0) {
			window.dispatchEvent(new CustomEvent('bookmarks-empty'));
		}
	},
});

export default bookmarkToggle;
